(ns app.front.view.property.owner
  (:require [app.domain.party.model :as party-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.util :refer [for-frag]]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::get-property-owner-info
  (fn [{:keys [db]} [_ application]]
    (let [workspace                                                        (:entity/parent application)
          {:keys [:property/id :property/integration-id :entity/location]} (workspace-model/single-property workspace)]
      {:db           (-> (assoc db ::loading? true ::modal-open? true)
                         (dissoc ::owners))
       :comm/command {:command          :property/owner-search
                      :data             (p/assoc-if
                                          {:group/id    (-> workspace :domain/authority-group :group/id)
                                           :coordinates [(:location.center/x location)
                                                         (:location.center/y location)]}
                                          :property/integration-id integration-id
                                          :property/id             id
                                          :municipality/number     (some-> workspace :workspace/municipality :municipality/number))
                      :on-success       [::get-property-owner-info.success]
                      :finally-dispatch [::get-property-owner-info.done]}})))


(rf/reg-event-db ::get-property-owner-info.success
  (fn [db [_ _ response]]
    (assoc db ::owners response)))


(rf/reg-event-db ::get-property-owner-info.done
  (fn [db _]
    (dissoc db ::loading?)))


(rf/reg-event-db ::close-modal
  (fn [db _]
    (-> (assoc db ::modal-open? false)
        (dissoc ::owners))))


(rf/reg-sub ::property-owner-parties
  (fn [[_ application-id]]
    (rf/subscribe [::entities/entities (filter #(and (party-model/active? %)
                                                     (= (:entity/parent %) application-id)))]))
  (fn [active-party-entities]
    ; has-role? works only for entities, so it is separated out from the active parties query
    (filter #(party-model/has-role? % :role/property-owner) active-party-entities)))


(rf/reg-sub ::owners :-> ::owners)
(rf/reg-sub ::loading? :-> ::loading?)
(rf/reg-sub ::modal-open? :-> ::modal-open?)


(defn external-ownership-info-modal [{:keys [lang tr] :as ctx} workspace]
  (let [application (workspace-model/workspace-application workspace)
        parties     (<sub [::property-owner-parties (:db/id application)])
        property    (-> workspace workspace-model/single-property)
        owner-data  (<sub [::owners])
        loading?    (<sub [::loading?])
        modal-open? (<sub [::modal-open?])]
    (cc/composed-modal
      {:open     modal-open?
       :on-close #(>evt [::close-modal])}
      (cc/modal-header {:close-modal #(>evt [::close-modal])
                        :title       (tr [:property/owner-info-modal-title]
                                         [(-> property :property/id)
                                          (-> property :property/integration-id)])})
      (cc/modal-body
        {}
        [:div.property-owner-info-modal
         [:h4.mt-3.mb-2 (tr [:property/owner-info-modal-app-info])]
         (if (seq parties)
           (cc/structured-list-wrapper
             {:class-name "property-owner-info-section"}
             (cc/structured-list-head
               {}
               (cc/structured-list-row
                 {:head true}
                 (cc/structured-list-cell
                   {:head true}
                   [:label (tr [:property/owner-name])])
                 (cc/structured-list-cell
                   {:head true}
                   [:label (tr [:property/street-address])])))
             (cc/structured-list-body
               {}
               (for-frag [{:db/keys [id] :as party} parties]
                 (cc/structured-list-row
                   {:key (str id)}
                   (cc/structured-list-cell
                     {:key (str id "-name")}
                     [:p (party-model/simple-name party lang)])
                   (cc/structured-list-cell
                     {:key (str id "-street")}
                     [:p
                      (party-model/get-user-key ctx party :user/street-address) ", "
                      (party-model/get-user-key ctx party :user/municipality) " "
                      (party-model/get-user-key ctx party :user/postal-code)])))))
           [:p (tr [:property/owner-info-modal-no-owners])])
         [:h4.mt-6.mb-2 (tr [:property/owner-info-modal-back-end-info])]
         (if loading?
           (cc/structured-list-skeleton)
           [:div
            (if (seq owner-data)
              (let [show-addr? (some :address owner-data)]
                (cc/structured-list-wrapper
                  {:class-name "property-owner-info-section"}
                  (cc/structured-list-head
                    {}
                    (cc/structured-list-row
                      {:head true}
                      (cc/structured-list-cell
                        {:head true}
                        [:label (tr [:property/owner-name])])
                      (when show-addr?
                        (cc/structured-list-cell
                          {:head true}
                          [:label (tr [:property/street-address])]))))
                  (cc/structured-list-body
                    {}
                    (for-frag [{:keys [name address]} owner-data]
                      (cc/structured-list-row
                        {:key name}
                        (cc/structured-list-cell {:key (str name "-name")}
                                                 [:p name])
                        (when show-addr?
                          (cc/structured-list-cell {:key (str name "-street")}
                                                   [:p address])))))))
              [:p (tr [:property/owner-info-not-found])])])])
      (cc/modal-footer
        {}
        (cc/button
          {:kind     :primary
           :on-click #(>evt [::close-modal])}
          (tr [:close]))))))
